import React, { useState, useCallback } from 'react';
import DesktopDemo from './DesktopDemo';
import './AppMockup.css';

const AppMockup = () => {
  const [demoKey, setDemoKey] = useState(0);

  // When demo completes, restart it
  const handleDemoComplete = useCallback(() => {
    setTimeout(() => {
      setDemoKey(k => k + 1);
    }, 2000); // Brief pause before restarting
  }, []);

  return (
    <div className="app-mockup-flipper">
      <div className="app-mockup">
        <div className="scanning-overlay"></div>

        {/* App Header */}
        <div className="mockup-header">
          <div className="app-logo">
            <span className="logo-test-in-mockup">QATE&nbsp;</span><span className="logo-agent-in-mockup">AI</span>
          </div>
          <div className="app-controls">
            <div className="status-indicator">
              <div className="status-dot"></div>
              <span className="status-text">AI Interacting</span>
            </div>
          </div>
        </div>

        {/* Demo Content - Mouse and login form simulation */}
        <DesktopDemo key={demoKey} onComplete={handleDemoComplete} />
      </div>
    </div>
  );
};

export default AppMockup;
